import { itemGroupUrl } from "../Config/Url";
import axios from "axios";

export const itemGroupServices = {
  getById,
  getSearch,
  create,
  update,
  deletePriceList,
};

async function getById(itemGroupId) {
  return axios
    .get(`${itemGroupUrl}/${itemGroupId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getSearch({ tenantId, searchName, pageIndex, pageSize }) {
  return axios
    .put(`${itemGroupUrl}/search`, {
      tenantId,
      searchName,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function create({ tenantId, name, description }) {
  return axios
    .post(`${itemGroupUrl}`, { tenantId, name, description })
    .then((res) => res)
    .catch((err) => err.response);
}

async function update({ itemGroupId, name, description }) {
  return axios
    .put(`${itemGroupUrl}/${itemGroupId}`, { name, description })
    .then((res) => res)
    .catch((err) => err.response);
}

async function deletePriceList(itemGroupId) {
  return axios
    .delete(`${itemGroupUrl}/${itemGroupId}`)
    .then((res) => res)
    .catch((err) => err.response);
}
